// extracted by mini-css-extract-plugin
export default {"document":"PdfViewer-module__document--lzHsU","page":"PdfViewer-module__page--P1lXX"};